// extracted by mini-css-extract-plugin
export default {"slideshow":"Question__slideshow___WcswR"};